/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerationRejectedTombstoneContainer_story = {
    readonly " $fragmentRefs": FragmentRefs<"CaretContainer_story">;
    readonly " $refType": "ModerationRejectedTombstoneContainer_story";
};
export type ModerationRejectedTombstoneContainer_story$data = ModerationRejectedTombstoneContainer_story;
export type ModerationRejectedTombstoneContainer_story$key = {
    readonly " $data"?: ModerationRejectedTombstoneContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerationRejectedTombstoneContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerationRejectedTombstoneContainer_story",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CaretContainer_story"
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '140b6ac652baf901f5a7ccd4ef15e47b';
export default node;
